"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function OurLocation() {
  return <section id="our-location" className="relative w-full h-[600px] flex items-center justify-center overflow-hidden bg-muted">
      {}
      <div className="absolute inset-0 w-full h-full">
        <iframe width="100%" height="100%" frameBorder="0" title="Our Location" scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" className="w-full h-full grayscale contrast-[0.9] brightness-[1.05] opacity-80" style={{
        filter: "grayscale(100%) contrast(90%) brightness(110%)"
      }} />
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-overlay pointer-events-none" />
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none backdrop-blur-[2px] bg-background/10" style={{
      maskImage: "radial-gradient(circle at center, transparent 30%, black 100%)",
      WebkitMaskImage: "radial-gradient(circle at center, transparent 30%, black 100%)"
    }} />

      {}
      <div className="relative z-10 px-4 w-full max-w-md">
        <Card className="w-full shadow-md rounded-lg bg-card/95 border-none backdrop-blur-sm">
          <CardContent className="flex flex-col items-center text-center p-8 gap-6">
            {}
            <div className="flex items-center justify-center size-12 rounded-full bg-accent/50">
              <MapPin className="size-6 text-ring" strokeWidth={2.5} />
            </div>

            {}
            <div className="space-y-1">
              <h3 className="text-primary font-bold font-sans text-xl tracking-tight">
                Headquarters
              </h3>
              <p className="text-primary/80 font-sans text-base leading-relaxed max-w-[240px] mx-auto">
                123 Agency Way, Creative District<br />
                New York, NY 10001
              </p>
            </div>

            {}
            <Separator className="w-full bg-border h-px" />

            {}
            <Button asChild variant="ghost" className="text-primary font-semibold hover:text-primary/80 hover:bg-transparent p-0 h-auto text-base">
              <Link to="https://maps.google.com" newTab>
                Get Directions
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>;
}